import { render, staticRenderFns } from "./view-shipment.vue?vue&type=template&id=a0b4542e"
import script from "./view-shipment.vue?vue&type=script&lang=js"
export * from "./view-shipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports